import * as React from 'react';
import CellBase from './cell-base';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var ProductTableCellImage = function ProductTableCellImage(_ref) {
  var children = _ref.children,
      headerImage = _ref.headerImage;
  return _jsx(CellBase, {
    mobileOrder: !headerImage ? 0 : 2,
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      variant: headerImage ? 'compounds.product-table.variants.redesign.cellImage.main' : 'compounds.product-table.cellImage.main'
    },
    children: _jsx("div", {
      sx: {
        position: 'relative',
        height: '100%',
        width: '100%',
        minHeight: headerImage ? 90 : 75,
        minWidth: headerImage ? 120 : 100,
        variant: headerImage ? 'compounds.product-table.variants.redesign.cellImage.imageWrapper' : 'compounds.product-table.cellImage.imageWrapper',
        img: {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          maxWidth: '100%',
          maxHeight: '100%',
          margin: 'auto',
          objectFit: 'contain',
          variant: headerImage ? 'compounds.product-table.variants.redesign.cellImage.image' : 'compounds.product-table.cellImage.image'
        }
      },
      children: children
    })
  });
};
export default ProductTableCellImage;
//# sourceMappingURL=cell-image.js.map